import {
  Box,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FC, useState } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

interface CustomPaginationProps {
  count: number;
}

const CustomPagination: FC<CustomPaginationProps> = ({ count }) => {
  const pageSizeOptions = [5, 10];

  const [pageSize, setPageSize] = useState(pageSizeOptions[0]);

  const handlePageSizeChange = (event: SelectChangeEvent<number>) => {
    setPageSize(event.target.value as number);
  };

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Select
        IconComponent={KeyboardArrowDownOutlinedIcon}
        sx={{
          width: "70px",
          backgroundColor: "#F9F9F9",
        }}
        value={pageSize}
        onChange={handlePageSizeChange}
      >
        {pageSizeOptions.map((size , index) => (
          <MenuItem value={size} key={index}>{size}</MenuItem>
        ))}
      </Select>
      <Pagination
        count={count}
        shape="rounded"
        sx={{
          "& .MuiPaginationItem-root": {
            "&.Mui-selected": {
              backgroundColor: "#182250",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "#182250",
              opacity: 0.8,
            },
            "&:hover": {
              backgroundColor: "#182250",
              opacity: 0.8,
            },
          },
        }}
      />
    </Box>
  );
};

export default CustomPagination;
